// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"05128aea","364":"9d31fe74","637":"a7ec46bf","706":"084825de"}[chunkId] + ".chunk.css";
};